import React, { useState, useContext, useRef } from "react";
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import ContractContext from '../../ContractContext'; //Required for all dApp components using contracts

import AdminSelection from "./AdminSelection";
import { useWeb3React } from "@web3-react/core";

const Admin = ({ data, getData, account, rocketFiPrice, bnbBalance }) => {

  const { library, } = useWeb3React();
  const isWalletConnected = () => account !== null;
  const contractContext = useContext(ContractContext);
  const contracts = contractContext.contracts;

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px', marginTop: '10px', marginBottom: '40px'}}>
        <AdminSelection data={data} getData={getData} />

      </div>
    </div>
  );
};

export default Admin;

